import { render, staticRenderFns } from "./ErrorStatusInfo.vue?vue&type=template&id=253e536d"
import script from "./ErrorStatusInfo.vue?vue&type=script&lang=js"
export * from "./ErrorStatusInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports